import { FC, SVGProps } from 'react'

export const ArrowDiagonal: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M8.26451 6.51376C8.25698 6.09962 8.58661 5.75778 9.00075 5.75025L17.6432 5.59312C17.8468 5.58942 18.0431 5.66867 18.1871 5.81267C18.3311 5.95666 18.4104 6.15302 18.4067 6.35663L18.2495 14.999C18.242 15.4132 17.9002 15.7428 17.486 15.7353C17.0719 15.7278 16.7423 15.3859 16.7498 14.9718L16.8731 8.18731L6.87343 18.187C6.58053 18.4799 6.10566 18.4799 5.81277 18.187C5.51987 17.8941 5.51987 17.4193 5.81277 17.1264L15.8125 7.12665L9.02802 7.25001C8.61388 7.25754 8.27204 6.92791 8.26451 6.51376Z"
			fill="currentColor"
		/>
	</svg>
)
